<template>
  <h1>ola mundo</h1>
</template>

<script>
// import AdminRecruiter from "layouts/AdminRecruiter.vue";

export default {
  // components: {'admin-recruiter': AdminRecruiter}
};
</script>

<style>
</style>